import { Box, FormControl, InputAdornment, MenuItem, Select, SelectChangeEvent, Typography } from "@mui/material";
import { PlatformTemplate } from "../../../interfaces/IExternalCommunication";
import {JSX} from "react";

interface Props {
    disabled?: boolean;
    placeholder?: string;
    variant?: "standard" | "outlined" | "filled";
    icon?: JSX.Element;
    title?: string;
    templates?: PlatformTemplate[];
    name: string;
    defaultValue?: string;
    value?: number;
    required?: boolean;
    onChange: (value: any) => void;
}

function PlatformTemplateSelectField({ disabled, placeholder, variant, icon, title, templates, name, defaultValue, value, required, onChange }: Props) {
    const handleSelectChange = (event: SelectChangeEvent<string>) => {
        if (onChange) {
            onChange(event);
        }
    };

    return (
        <Box>
            {title && (
                <Typography variant="body2" gutterBottom>
                    {title}
                </Typography>
            )}
            <FormControl disabled={disabled} fullWidth>
                <Select
                    sx={{
                        backgroundColor: 'background.paper',
                    }}
                    size="medium"
                    required={required}
                    variant={variant}
                    startAdornment={
                        <InputAdornment position="start">
                            {icon}
                        </InputAdornment>
                    }
                    displayEmpty={true}
                    name={name}
                    defaultValue={defaultValue}
                    value={value !== 0 ? value?.toString() : ""}
                    onChange={handleSelectChange}
                    MenuProps={{
                        slotProps: {
                            paper: {
                                sx: {
                                    borderRadius: "8px",
                                },
                            },
                        },
                    }}
                >
                    {templates?.map((template) => (
                        <MenuItem key={template.id} value={template.id}>
                            <Typography variant="body2">{template.subject}</Typography>
                        </MenuItem>
                    ))};
                </Select>
            </FormControl>
        </Box>
    );
}

export default PlatformTemplateSelectField;
